import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading5 } from '@blueprint/heading';
import { ButtonLink } from '@blueprint/ui';

export const WidgetWrapper = styled('div')(
    ({ theme: { spacing } }) => css`
        margin-top: ${spacing['64px']};
    `
);

export const HeadingRow = styled('div')(
    ({ theme: { spacing } }) => css`
        margin-left: ${spacing['8px']};
        margin-bottom: ${spacing['24px']};
        display: flex;
        align-items: center;
        padding-right: ${spacing['8px']};
        ${Heading5} {
            margin-left: ${spacing['16px']};
        }
        ${ButtonLink} {
            margin-left: auto;
            svg {
                margin-left: ${spacing['8px']};
            }
        }
    `
);

export const StyledListingCardScrollRow = styled('div')(
    ({ theme: { spacing } }) => css`
        margin: ${spacing['8px']};
        display: flex;
        flex-direction: row;
        overflow-x: auto;
        flex-wrap: nowrap;
        align-items: stretch; /* force cards to all take height of tallest */
        width: 100%;

        > .trigger-when-visible {
            margin: ${spacing['4px']} ${spacing['8px']};
            &:nth-of-type(1) {
                margin-left: ${spacing[
                    '4px'
                ]}; // just enough to show focus ring
            }

            &:last-of-type {
                margin-right: ${spacing[
                    '4px'
                ]}; // just enough to show focus ring
            }
            height: auto; /* allow their height to be set by the flex rules of container */
            flex-basis: 17.5rem;
            flex-grow: 0;
            flex-shrink: 0;
        }
    `
);
